export enum CheckoutRoutePath {
    Checkout = '/checkout',
    Delivery = '/delivery',
    Payment = '/payment',
    Confirmation = '/confirmation',
    Order = '/order',
  }